<template>
    <div class="request-toolbar">
        <h2 class="request-toolbar__title">{{ title }}</h2>
        <div class="request-toolbar__actions">
            <Select :value="year" class="request-toolbar__year" @on-change="handleYearChanged">
                <Option v-for="item in yearOptions" :key="item" :value="item">{{ item }}</Option>
            </Select>
            <Button class="pt-btn-3 request-toolbar__new" @click="$emit('create')">
                <Icon type="md-add" size="18" /> {{ buttonLabel }}
            </Button>
        </div>
    </div>
</template>

<script>
import { yearOptions } from './years';

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        buttonLabel: {
            type: String,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
    },
    computed: {
        yearOptions,
    },
    methods: {
        handleYearChanged(year) {
            this.$emit('year-changed', year);
        },
    },
};
</script>

<style lang="scss" scoped>
.request-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin: 12px 0 20px;
    padding: 28px 32px;
    border: 1px solid #e8eaec;
    border-radius: 4px;
    background: #fff;

    &__title {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #211841;
    }

    &__actions {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    &__year {
        width: 120px;
    }

    &__new {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }
}

@media screen and (max-width: 767px) {
    .request-toolbar {
        padding: 16px;

        &__title {
            font-size: 20px;
        }

        &__actions {
            width: 100%;
        }

        &__year {
            flex: 0 0 100px;
        }

        &__new {
            flex: 1;
            justify-content: center;
        }
    }
}
</style>
